import React, { useEffect, useState } from 'react';
import * as language from '../constants/languages';
import '../styles/ProductDetails.css';
import ProductActionSection from './ProductActionSection';

export default function ProductDetailsSectionInfo({ productData, isSpecification }) {
    const [currencySymbol, setcurrencySymbol] = useState()
    // async function GetCompanyInfo() {
    // 	 useEffect(() => {
    //     GetCompanyInfo()
    // }, [])
    console.log("productData", productData)

    const value = localStorage.getItem('companyInfo')

    useEffect(() => {
        const value = localStorage.getItem('companyInfo');

        if (value === null || value === undefined) {
            setcurrencySymbol('');
        } else {
            const companyInfo = JSON.parse(value);
            setcurrencySymbol(companyInfo?.currencySymbol || '');
        }
    }, []);
    return (

        <div className='product-section-info'>
            <div style={{ padding: '1rem' }}>
                <p className='textCommonStyledDetails'>{productData.productName}</p>
                {
                    productData.regionalLanguage != (null || "") &&
                    <p style={{ fontFamily: 'Poppins-Regular', fontSize: 14 }}>{productData.regionalLanguage}</p>
                }
                {
                    productData.isStockAvailable == false ?
                        <p style={{ fontFamily: 'BeVietnamPro-Regular', fontSize: 14, color: language.red }}>{language.outStockLabel}</p>
                        :
                        <p style={{ fontFamily: 'BeVietnamPro-Regular', fontSize: 14, color: language.green }}>{language.inStockLabel}</p>
                }

                <div style={{ marginTop: 15 }}>
                    {
                        productData.oRate == null ?
                            <div>
                                {
                                    productData.sRate < (productData.mrp == null ? productData.sRate : productData.mrp) ?
                                        <div style={{ alignItems: 'flex-start', marginBottom: 3, paddingTop: 0 }}>
                                            <div className="rate-style">
                                                <div className="mrp-style">
                                                    <span style={{ fontFamily: 'Roboto-medium', fontSize: 16 }}>MRP :</span>
                                                    <p className="pre-mrp-style">
                                                        {currencySymbol} {(productData.mrp * productData.incrementValue).toFixed(2)}
                                                    </p>
                                                    {productData.savedPercentage && (
                                                        <span style={{ fontFamily: 'Gilroy-medium', color: '#388E3C', fontSize: 16, fontWeight: 600, marginLeft: 8 }}>
                                                            {productData.savedPercentage}% off
                                                        </span>
                                                    )}
                                                </div>
                                                <p style={{ fontFamily: 'Roboto, sans-serif', fontSize: 26, fontWeight: 700, color: '#FF0000', margin: '2px 0 0 0' }}>
                                                  Sale Price:  {currencySymbol} {(productData.sRate * productData.incrementValue).toFixed(2)}
                                                </p>
                                                <p style={{ fontFamily: 'Poppins-Regular', fontSize: 11.5, fontWeight: 600, color: '#16a34a', marginTop: 2, marginBottom: 0 }}>
                                                    GST Additional 18%
                                                </p>
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <p style={{ marginHorizontal: 0, fontFamily: 'Roboto, sans-serif', fontSize: 24, fontWeight: 700, color: '#f70505', margin: 0 }}>
                                                Sale Price:  {currencySymbol} {(productData.sRate * productData.incrementValue).toFixed(2)}
                                            </p>
                                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: 11.5, fontWeight: 600, color: '#16a34a', marginTop: 2, marginBottom: 0 }}>
                                                GST Additional 18%
                                            </p>
                                        </div>
                                }
                            </div>
                            :
                            <div>
                                {
                                    productData.oRate < (productData.mrp == null ? productData.sRate : productData.mrp) ?
                                        <div style={{ alignItems: 'flex-start', marginBottom: 3, paddingTop: 0 }}>
                                            <div className="rate-style">
                                                <div className="mrp-style">
                                                    <span style={{ fontFamily: 'Roboto, sans-serif', fontSize: 16 }}>MRP :</span>
                                                    <p className="pre-mrp-style">
                                                        {currencySymbol} {((productData.mrp == null ? productData.sRate : productData.mrp) * productData.incrementValue).toFixed(2)}
                                                    </p>
                                                    {productData.savedPercentage && (
                                                        <span style={{ fontFamily: 'Gilroy-medium', color: '#388E3C', fontSize: 16, fontWeight: 600, marginLeft: 8 }}>
                                                            {productData.savedPercentage}% off
                                                        </span>
                                                    )}
                                                </div>
                                                <p style={{ fontFamily: 'Roboto, sans-serif', fontSize: 26, fontWeight: 700, color: '#f70505', margin: '2px 0 0 0' }}>
                                                    Sale Price:  {currencySymbol} {(productData.oRate * productData.incrementValue).toFixed(2)}
                                                </p>
                                                <p style={{ fontFamily: 'Poppins-Regular', fontSize: 11.5, fontWeight: 600, color: '#16a34a', marginTop: 2, marginBottom: 0 }}>
                                                    GST Additional 18%
                                                </p>
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <p style={{ fontFamily: 'Roboto, sans-serif', fontSize: 24, fontWeight: 700, color: '#f70505', margin: 0 }}>
                                                Sale Price:  {currencySymbol} {(productData.oRate * productData.incrementValue).toFixed(2)}
                                            </p>
                                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: 11.5, fontWeight: 600, color: '#16a34a', marginTop: 2, marginBottom: 0 }}>
                                                GST Additional 18%
                                            </p>
                                        </div>
                                }
                            </div>
                    }
                </div>
                {
                    productData.shortDescription != ("" && null && undefined) &&
                    <>
                        <p className='product-section-info-text'>Product Description</p>
                        <p style={{ fontFamily: 'Poppins-Light', marginTop: 10, fontSize: 15, lineHeight: 2, textAlign: 'justify' }}>{productData?.shortDescription ? productData.shortDescription : null}</p>
                    </>
                }
                {
                    productData.longDescription != ("" && null && undefined) &&
                    <>
                        <p className='product-section-info-text' style={{ marginTop: 10, }}>Details and Specifications</p>
                        <p style={{ fontFamily: 'Poppins-Light', marginTop: 10, fontSize: 15, lineHeight: 2, textAlign: 'justify' }}>{productData?.longDescription ? productData.longDescription : null}</p>
                    </>
                }

            </div >
        </div >

    )
}





